// Row action button classes for the Now feed: a solid blue primary and white bordered
// buttons for everything else, so the row's main action reads at a glance and the rest
// stay clearly clickable without competing with it.
//
// Sized from the mockup: text-sm with px-3.5 and py-1 plus the 1px border is a 30px-tall
// button, the height measured there. The keyboard focus ring is a box-shadow, so it never
// changes a row's height.

const BASE =
  "rounded-lg border px-3.5 py-1 text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500";

/** The row's main action (Met, Reply, Release, Open, View, Chased, Take): solid blue. */
export const BTN_PRIMARY = `${BASE} border-blue-600 bg-blue-600 text-white hover:border-blue-700 hover:bg-blue-700`;

/** Secondary actions and the row's dismiss control: white with a gray border. */
export const BTN_QUIET = `${BASE} border-gray-300 bg-white text-gray-700 hover:bg-gray-50 hover:text-gray-900 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-200 dark:hover:bg-gray-700 dark:hover:text-white`;

/** Assign: white with a dashed border, present only where the row can actually be assigned. */
export const BTN_ASSIGN = `${BASE} border-dashed border-gray-300 bg-white text-gray-500 hover:border-gray-400 hover:bg-gray-50 hover:text-gray-700 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-400 dark:hover:border-gray-500 dark:hover:bg-gray-700 dark:hover:text-gray-200`;
